module.exports = __webpack_public_path__ + "img/7.388a6b1a.svg";